export default __webpack_public_path__ + "bee9c106caefed114dc9db8e57d5080f.png";